import { postMediaS3Get_upload_pre_url } from '@common/oneclub/services/api/bff/s3/api'
import Api from '@common/oneclub/services/http'
import { OneMessage } from '@yy/one-ui'

interface IS3Config {
  scene: string
  fileName?: string
}

const parseUploadInfo = (infoArray: Record<string, any>[]) => {
  if (!infoArray) {
    return {}
  }

  const data = {}
  infoArray.forEach((info) => {
    data[info.key] = info.value
  })

  return data
}

/** 生成预授权上传URL */
export const getAmazonS3Api = async (params: IS3Config) => {
  if (!params) {
    OneMessage.info('required params config, must be Object')
    throw new Error('required params config, must be Object')
  }

  const data = await postMediaS3Get_upload_pre_url(params)
  const { actionUrl, fields, headers, fileId, preview } = data
  const uploadFormData = new FormData()

  // 组装formdata 数据
  fields.forEach((item: any) => {
    uploadFormData.append(item.key, item.value)
  })

  return {
    actionUrl,
    data: uploadFormData,
    headers: { ...parseUploadInfo(headers || []), 'content-type': 'multipart/form-data' },
    fileId,
    fields,
    preview,
  }
}

/** 上传到亚马逊 */
export const uploadAmazon = async (params: { url: string; formData: any; headers: any; onUploadProgress?: (e: ProgressEvent) => void }) => {
  const response = await Api.post(params.url, params.formData, {
    headers: { ...params.headers },
    onUploadProgress: params?.onUploadProgress,
    timeout: 60e3,
    withCredentials: false,
  })
  const { status } = response
  if (status === 204) {
    return {
      bizCode: 'SUCCESS',
      data: response,
    }
  }

  return response
  // return Promise.reject({
  //   bizCode: 'UPLOAD_FAIL',
  //   bizMessage: 'batchOrder.uploadError',
  //   message: 'batchOrder.uploadError',
  // })
}
interface IDoUpload {
  scene: string
  file: any
  /** 上传进度事件 */
  onUploadProgress?: (e: ProgressEvent) => void
  fileName?: string
}

interface IUseUploadImage {
  successCallback: FnType
  errorCallback: FnType
}

export function useUploadImage(option = {} as IUseUploadImage) {
  const { successCallback, errorCallback } = option

  const doUpload = async (config: IDoUpload) => {
    if (!config) {
      OneMessage.info('required params config')
      return
    }
    const { scene, fileName } = config
    try {
      const {
        actionUrl,
        data: formData,
        headers,
        fileId,
        preview,
      } = await getAmazonS3Api({
        scene,
        fileName,
      })
      if (actionUrl && fileId) {
        formData.append('file', config.file)
        await uploadAmazon({ url: actionUrl, formData, headers })
        // 直接把preview字段返回，提交给对应的保存表单接口，保存表单需要根据这个url重新解析成oss://xxxx格式的内容
        successCallback(preview)
      }
    } catch (e) {
      errorCallback(e)
    }
  }

  return {
    doUpload,
  }
}
